/* @flow */
import Button from 'components/Button.jsx';
import File from 'entities/File';
import Glyph from 'components/Glyph.jsx';
import MediaPlayer from 'components/MediaPlayer.jsx';
import React from 'react';
import { isSupportedType } from 'lib/VideoSupport';
import _ from 'lodash';
import cx from 'classnames';

import './styles/Video.scss';

class Video extends React.Component {
  static propTypes = {
    src: React.PropTypes.string.isRequired,
    file: React.PropTypes.instanceOf(File),
  };

  static isSupportedType = isSupportedType;

  state = {
    id: _.uniqueId(),
    started: false,
    showControl: false,
  };

  handleClick = () => {
    if (!this.state.started) {
      this.setState({ started: true });
    }

    const { player } = this.refs;
    if (player.state.playing) {
      player.pause();
    } else {
      player.play();
    }
  };

  handleMouseEnter = () => {
    this.setState({ showControl: true });
  };

  handleMouseLeave = () => {
    const { player } = this.refs;
    if (!player.state.playing) {
      return;
    }

    this.setState({ showControl: false });
  };

  render() {
    let play;
    if (!this.state.started) {
      play = (
        <Button
          className="Video-playButton"
          color="white"
          onClick={this.handleClick}
          eventElementName="Video-playButton">
          <Glyph name="play" size="xlarge" color="brand" solo />
        </Button>
      );
    }

    return (
      <div
        className="Video"
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}>
        <video id={this.state.id} src={this.props.src} onClick={this.handleClick}>
          Your browser does not support the <code>video</code> element.
        </video>
        {play}
        <MediaPlayer
          className={cx({
            'Video-controls': true,
            'Video-controlsHidden': !this.state.started || !this.state.showControl,
          })}
          ref="player"
          playerId={this.state.id}
          theme="dark"
          fullscreen
          src={this.props.src}
        />
      </div>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video.jsx